/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'fabric.editor.headingLink.ascSortingLabel': 'rosnąco',
  'fabric.editor.headingLink.copied': 'Skopiowano!',
  'fabric.editor.headingLink.copyAnchorLink': 'Skopiuj łącze do nagłówka',
  'fabric.editor.headingLink.copyAriaLabel': 'Kopiuj',
  'fabric.editor.headingLink.descSortingLabel': 'malejąco',
  'fabric.editor.headingLink.failedToCopy': 'Kopiowanie nie powiodło się',
  'fabric.editor.headingLink.noneSortingLabel': 'Brak',
  'fabric.editor.inlineComment.marker.end': 'koniec komentarza śródwierszowego',
  'fabric.editor.inlineComment.marker.start': 'początek komentarza śródwierszowego',
  'fabric.editor.status.accessibilityLabel': 'status:',
};
